import {
  constants, React,
  styled, useEffect,
  useState
} from "../../imports";
import "./Accordion.css";
import AccordionInitiator from "./AccordionInitiator";
import AccordionNotInitiator from "./AccordionNotInitiator";
import AccordionSingleBuyer from "./AccordionSingleBuyer";

function Accordion({ data, totalCart, parentPage, orderId }) {
  const [totalCartState, setTotalCartState] = useState();
  useEffect(() => {
    if (totalCart) {
      let tmp = parseFloat(totalCart.replace(",", "."))
      setTotalCartState(
        tmp.toLocaleString('DE-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
    }

  }, [totalCart])

  return (
    <>
      <ListWrapper>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <ListHeading>
            <HeadingSmall style={{marginTop:0}}>Liste</HeadingSmall>
            <HeadingSmall style={{marginTop:0}}>Preis</HeadingSmall>
          </ListHeading>
          {orderId && !(data.length == 1 && (data[0].orderers[0].name == "initiator" || parentPage === "DataInputSubbesteller")) &&  <HeadingSmallDM style={{ marginLeft: "30px", marginTop: 0 }}>bezahlt</HeadingSmallDM>}
        </div>
      </ListWrapper>
      {data && (data.length == 1 && (data[0].orderers[0].name == "initiator" || parentPage === "DataInputSubbesteller"))
        ?

        data[0].orderers[0].products.map((product, i2) => {

          return (
            <AccordionSingleBuyer
              data={data}
              product={product}
              parentPage={parentPage}
              i2={i2}
              orderId={orderId}
              setTotalCart={(total) => {
                let tmp = parseFloat(totalCartState.replace(",", ".")) - total
                setTotalCartState(
                  tmp.toLocaleString('DE-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }))
              }}
            ></AccordionSingleBuyer>
          );
        })
        : data.map((list, index) => {
          return list.name != "initiator" ? (
            <AccordionNotInitiator
              data={data}
              list={list}
              parentPage={parentPage}
              index={index}
              orderId={orderId}
            ></AccordionNotInitiator>
          ) : (
              <AccordionInitiator
                data={data}
                list={list}
                index={index}
                orderId={orderId}
                parentPage={parentPage}
              ></AccordionInitiator>
            );
        })}
      <Footer
      >
        <Paragraph>Gesamt</Paragraph>
        <ParagraphBold>
          <strong>€ {totalCartState}</strong>
        </ParagraphBold>
      </Footer>
    </>
  );
}

export default Accordion;


const Footer = styled.div`
width: 330px;
display: flex;
justify-content: space-between;
flex-direction: row;
@media (max-width: 374px){
    width: unset;
  }
`;

const ListWrapper = styled.div`
  /* padding: 20px 0; */
  /* min-width: 380px; */
`;

const HeadingSmall = styled.h4`
  font-family: "Montserrat";
  font-weight: 300;
  color: #4d4d4d;
  font-size: 16px;
  letter-spacing: 0.4px;
`;

const HeadingSmallDM = styled.h4`
  font-family: "Montserrat";
  font-weight: 300;
  color: #4d4d4d;
  font-size: 16px;
  letter-spacing: 0.4px;
  @media (max-width: 770px){
    display: none;
  }
`;

const ListHeading = styled.div`
  width: 330px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;


const Paragraph = styled.p`
  font-family: "Montserrat";
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 0.35;
  color: #4d4d4d;
`;

const ParagraphBold = styled.p`
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.35;
  color: #4d4d4d;
`;

